var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 22,
    height: 18,
    rx: 9,
    fill: "#DDE3E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26842_7829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1672 6.66634H14.5838V5.49967C14.5838 3.88967 13.2772 2.58301 11.6672 2.58301C10.0572 2.58301 8.75049 3.88967 8.75049 5.49967V6.66634H8.16716C7.52549 6.66634 7.00049 7.19134 7.00049 7.83301V13.6663C7.00049 14.308 7.52549 14.833 8.16716 14.833H15.1672C15.8088 14.833 16.3338 14.308 16.3338 13.6663V7.83301C16.3338 7.19134 15.8088 6.66634 15.1672 6.66634ZM9.91716 5.49967C9.91716 4.53134 10.6988 3.74967 11.6672 3.74967C12.6355 3.74967 13.4172 4.53134 13.4172 5.49967V6.66634H9.91716V5.49967ZM15.1672 13.6663H8.16716V7.83301H15.1672V13.6663ZM11.6672 11.9163C12.3088 11.9163 12.8338 11.3913 12.8338 10.7497C12.8338 10.108 12.3088 9.58301 11.6672 9.58301C11.0255 9.58301 10.5005 10.108 10.5005 10.7497C10.5005 11.3913 11.0255 11.9163 11.6672 11.9163Z",
    fill: "#697377"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26842_7829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4.66699 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/Chip.d22470f0.svg";
export { ForwardRef as ReactComponent };